import axios from "../configApi";

// POST : {{url}}/services/{{service_id}}/reject-draft
export const rejectDraftService = async (serviceId: string) => {
  try {
    const res = await axios.post(`/services/${serviceId}/reject-draft`);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// PUT : {{url}}/services/{{service_id}}/mark-validated
export const markValidatedService = async (serviceId: string) => {
  try {
    const res = await axios.put(`/services/${serviceId}/mark-validated`);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
